import { Avatar, AvatarProps } from "@chakra-ui/react";

import { getOrganizationLogoUrl } from "@/common/utils/organizationLogoUrl";

const logoSizes = {
  "2xs": 48,
  xs: 48,
  sm: 48,
  xl: 192,
} as const;

type Sizes = keyof typeof logoSizes;

export default function OrgLogo({
  name,
  url,
  size,
  ...props
}: {
  name: string;
  url: string | null;
  size: Sizes;
} & Omit<AvatarProps, "size">) {
  const urlWithTransformation = url
    ? getOrganizationLogoUrl(url, logoSizes[size])
    : null;
  return (
    <Avatar
      bg={urlWithTransformation ? "transparent" : "brand.500"}
      borderRadius="25%"
      color="white"
      ignoreFallback={!!urlWithTransformation}
      name={name}
      size={size}
      src={urlWithTransformation ?? undefined}
      {...props}
    />
  );
}
